import * as C from 'constants/Redux'
import sessions from 'constants/Sessions'

export const { incoming, outgoing } = sessions.direction
export const { decline } = sessions.options

const PREFIX = 'SESSIONS / '
const SESSION = `${PREFIX}SESSION`

const INCOMING = `${PREFIX}INCOMING`
const OUTGOING = `${PREFIX}OUTGOING`
const HOLD = `${PREFIX}HOLD`
const PARK = `${SESSION}_PARK`
const MERGED = `_MERGED`

export const OUTGOING_CREATE = OUTGOING + C.CREATE
export const INCOMING_CREATE = INCOMING + C.CREATE
export const INCOMING_ACCEPT = `${INCOMING}_ACCEPT`
export const INCOMING_BLOCK = `${INCOMING}_BLOCK`
export const INCOMING_SILENCE = `${INCOMING}_SILENCE`

export const CONNECTING = `${PREFIX}CONNECTING`
export const MEDIA_CONNECTED = `${PREFIX}MEDIA_CONNECTED`
export const IS_PLAY_LOCAL_RING_TONE = `${PREFIX}IS_PLAY_LOCAL_RING_TONE`
export const ACCEPTED = `${PREFIX}ACCEPTED`

export const SESSION_ADD = `${SESSION}_ADD`
export const SESSION_ENDED = `${SESSION}_ENDED`
export const SESSION_TERMINATED = `${SESSION}_TERMINATED`
export const SESSION_ACTIVE_TOGGLE = `${SESSION}_ACTIVE${C.TOGGLE}`
// TODO standardize naming
export const SESSIONS_MERGE = `${SESSION}S_MERGE`
export const SESSIONS_MERGED_TERMINATED = `${SESSION}S_MERGED_TERMINATED`
export const HOLD_TOGGLE_MERGED = `${PREFIX}HOLD${MERGED}${C.TOGGLE}`
export const MUTE_TOGGLE_MERGED = `${PREFIX}MUTE${MERGED}${C.TOGGLE}`
export const TRACKS_TOGGLE_MERGED = `${PREFIX}TRACKS${MERGED}${C.TOGGLE}`
export const TOGGLE_DELAY_MIX_MERGED = `${PREFIX}DELAY_TRACKS${MERGED}${C.TOGGLE}`
export const HOLD_MERGED = `${PREFIX}HOLD${MERGED}`
export const MUTE_MERGED = `${PREFIX}MUTE${MERGED}`
export const TRACKS_MIX_MERGED = `${PREFIX}TRACKS_MIX${MERGED}`
export const ADD_DELAY_MIX_MERGED = `${PREFIX}ADD_DELAY_MIX${MERGED}`
export const ADD_RECEIVED_STREAM_MERGED = `${PREFIX}ADD_RECEIVED_STREAM${MERGED}`
export const UNHOLD_MERGED = `${PREFIX}UNHOLD${MERGED}`
export const UNMUTE_MERGED = `${PREFIX}UNMUTE${MERGED}`
export const TRACKS_UNMIX_MERGED = `${PREFIX}TRACKS_UNMIX${MERGED}`
export const REMOVE_DELAY_MIX_MERGED = `${PREFIX}REMOVE_DELAY_MIX${MERGED}`
// parking
export const SESSION_PARK_PENDING = PARK + C.PENDING
export const SESSION_PARK_FULFILLED = PARK + C.FULFILLED
export const SESSION_PARK_REJECTED = PARK + C.REJECTED
export const SESSION_PARK_TERMINATED = `${PARK}_TERMINATED`
export const SESSION_UNPARKED_ELSEWHERE = `${PARK}_UNPARKED_ELSEWHERE`
export const SESSION_UNPARKED = `${PARK}_UNPARKED`
// transfers
export const SESSION_TRANSFER = `${SESSION}_TRANSFER`
export const SESSION_TRANSFER_VOICEMAIL = `${SESSION_TRANSFER}_VOICEMAIL`
// warm transfers
const WARM = `${SESSION_TRANSFER}_WARM`
export const SESSION_TRANSFER_WARM_SET = WARM + C.SET
export const SESSION_TRANSFER_WARM_PENDING = WARM + C.PENDING
export const SESSION_TRANSFER_WARM_FULFILLED = WARM + C.FULFILLED

export const MUTE_TOGGLE = `${PREFIX}MUTE${C.TOGGLE}`
export const UNHOLD_ACTIVE = `${PREFIX}UNHOLD_ACTIVE`
export const HOLD_ACTIVE = `${HOLD}_ACTIVE`
export const HOLD_TOGGLE = HOLD + C.TOGGLE
// TODO move to config reducer
export const TRANSFER_TOGGLE = `${PREFIX}TRANSFER${C.TOGGLE}`
export const DIALPAD_TOGGLE = `${PREFIX}DIALPAD${C.TOGGLE}`
export const ADD_CALL_TOGGLE = `${PREFIX}ADD_CALL${C.TOGGLE}`
export const ACTION_CLEAR = `${PREFIX}ACTION${C.CLEAR}`
export const ADD_HOLD_TOGGLING = `${PREFIX}ADD_HOLD_TOGGLING`
export const REMOVE_HOLD_TOGGLING = `${PREFIX}REMOVE_HOLD_TOGGLING`

export const INITIAL_STATE = {
  connecting: false,
  connected: false,
  activeSessionIndex: -1,
  error: false,
  transfer: false,
  dialpad: false,
  action: false,
  silenced: false,
  list: [],
  merged: {
    ids: [],
    mute: false,
    hold: false,
    tracksAreMixed: false,
    needToMixWithDelay: false,
    receivedStream: null,
  },
  parked: {},
  parkingTimeout: {},
  warmTransfer: {
    ids: [],
    pendingId: false,
    transferring: false,
  },
}
